import { Link, useLocation } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  const location = useLocation();
  const isVendor = location.pathname.startsWith('/vendor');

  const homePath = isVendor ? '/vendor/dashboard' : '/clients';
  const homeLabel = isVendor ? 'Back to Dashboard' : 'Back to Clients';
  const accentColor = isVendor ? 'teal' : 'purple';

  const buttonClass = accentColor === 'teal'
    ? 'bg-teal-600 hover:bg-teal-700 focus:ring-teal-500'
    : 'bg-purple-600 hover:bg-purple-700 focus:ring-purple-500';

  const linkClass = accentColor === 'teal'
    ? 'text-teal-600 hover:text-teal-700 dark:text-teal-400 dark:hover:text-teal-300'
    : 'text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300';

  return (
    <div className="flex items-center justify-center min-h-[70vh]">
      <div className="text-center px-4">
        <p className="text-7xl font-bold text-gray-200 dark:text-gray-700">404</p>
        <h1 className="mt-4 text-xl font-bold text-gray-900 dark:text-white">Page Not Found</h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 max-w-sm mx-auto">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link
            to={homePath}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium text-white ${buttonClass} focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors`}
          >
            <Home size={16} />
            {homeLabel}
          </Link>
          <button
            onClick={() => window.history.back()}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium ${linkClass} border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors`}
          >
            <ArrowLeft size={16} />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
